<mat-dialog-content [style.pointerEvents]="'none'"
                    class="mat-typography pointer"
                    [style.backgroundImage]="'url(' + url + ')'"
                    (click)="download()">
</mat-dialog-content>
